import { useNavigate, useParams } from 'react-router-dom';

import { useIntegration } from 'services/repositories/integrations/integrations';
import { useCurrentPartner } from 'services/repositories/partners/partners';
import { getTradePartner } from 'support/helpers/relationships/relationships';
import { Connectors, DocumentType, RelationshipV2 } from 'support/types';
import { useConnectionNavigation } from 'pages/Connections/ConnectionDetailsPage/contexts/ConnectionNavigationContext';

import { ConnectionTestGuidelines } from './components/ConnectionTestGuidelines/ConnectionTestGuidelines';
import { TestDocumentsSection } from './components/TestDocumentsSection/TestDocumentsSection';

export const ConnectionsTestNonWebEDI = ({ relationship }: { relationship: RelationshipV2 }) => {
  const navigate = useNavigate();
  const { partnerId } = useParams<{ partnerId: string }>();
  const { data: currentPartner } = useCurrentPartner();
  const { routeTo } = useConnectionNavigation();
  const senderIntegration = relationship.sender_integration?.testing || relationship.sender_integration?.production;
  const { data: integration } = useIntegration({
    variables: { id: senderIntegration?.id, withConfiguration: true },
    enabled: Boolean(senderIntegration),
  });

  if (!relationship || !senderIntegration || !integration) {
    return null;
  }
  const otherPartner = currentPartner && getTradePartner(relationship, currentPartner?.id);

  return (
    <div className="space-y-8 divide-y divide-gray-200 first:-mt-8 *:first:pt-8">
      <ConnectionTestGuidelines
        connectorConfig={integration?.connectorConfig}
        connector={integration.connector as Connectors}
        relationship={relationship}
      />
      <TestDocumentsSection
        documentType={relationship.message_type as DocumentType | undefined}
        receiverPartner={otherPartner}
        onSuccess={() =>
          navigate(routeTo('relationshipDetails', { partnerId: partnerId!, relationshipId: relationship.id }))
        }
        relationshipId={relationship.id}
      />
    </div>
  );
};
